function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.6 10c-.2 0-.3 0-.4-.2-.2-.1-.2-.5 0-.7l2.5-2.5H2c-.3 0-.6-.3-.6-.6s.3-.6.6-.6h6.7L6.2 2.9c-.2-.2-.2-.6 0-.8.2-.2.6-.2.8 0l3.5 3.5.2.2v.4c0 .1-.1.2-.2.2L7 9.8c-.1.2-.2.2-.4.2z"
});

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _ref);
}

export default SvgArrowRight;